import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useUserContext } from "../contexts/UserContext";
import { toast } from "react-toastify";
import { API_URL } from '../config/api';

export default function StockManagement() {
  const { user } = useUserContext();
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({
    productId: "",
    type: "ENTREE",
    source: "ACHAT",
    quantity: "",
    commentaire: ""
  });

  useEffect(() => {
    fetch(`${API_URL}/products?adminId=${user._id}`)
      .then(res => res.json())
      .then(setProducts);
  }, [user]);

  const submit = async e => {
    e.preventDefault();

    const res = await fetch(
      `${API_URL}/stock/mouvement`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, adminId: user._id })
      }
    );

    if (!res.ok) return toast.error("Erreur stock");

    toast.success("Stock mis à jour");
    setForm({ ...form, quantity: "", commentaire: "" });
  };

  return (
    <>
      <Navbar />

  <div className="dashboard-wrapper">
       <div className="container">
        <h2>📦 Gestion du stock</h2>

        <form onSubmit={submit} className="card form-grid">
          <select
            value={form.productId}
            onChange={e => setForm({ ...form, productId: e.target.value })}
            required
          >
            <option value="">Produit</option>
            {products.map(p => (
              <option key={p._id} value={p._id}>
                {p.title} (Stock: {p.stock})
              </option>
            ))}
          </select>

          <select
            value={form.type}
            onChange={e => setForm({ ...form, type: e.target.value })}
          >
            <option value="ENTREE">Entrée</option>
            <option value="SORTIE">Sortie</option>
          </select>

          <select
            value={form.source}
            onChange={e => setForm({ ...form, source: e.target.value })}
          >
            <option value="ACHAT">Achat</option>
            <option value="VENTE">Vente</option>
            <option value="PERTE">Perte</option>
            <option value="INVENTAIRE">Inventaire</option>
          </select>

          <input
            type="number"
            placeholder="Quantité"
            value={form.quantity}
            onChange={e => setForm({ ...form, quantity: e.target.value })}
            required
          />

          <input
            placeholder="Commentaire"
            value={form.commentaire}
            onChange={e => setForm({ ...form, commentaire: e.target.value })}
          />

          <button className="btn-primary">Valider</button>
        </form>
      </div>
     </div>

      <Footer />

      {/* ================= CSS ================= */}
      <style>{`
        .page {
          padding: 30px;
          background: #f5f7fb;
          min-height: 100vh;
        }

        h2 {
          margin-bottom: 20px;
        }

        .card {
          background: #fff;
          padding: 20px;
          border-radius: 14px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.08);
          max-width: 900px;
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 15px;
          align-items: center;
        }

        select, input {
          padding: 10px 12px;
          border-radius: 8px;
          border: 1px solid #ddd;
          font-size: 0.95rem;
        }

        select:focus,
        input:focus {
          outline: none;
          border-color: #4f46e5;
        }

        .btn-primary {
          background: #4f46e5;
          color: white;
          padding: 10px;
          border-radius: 10px;
          border: none;
          cursor: pointer;
          font-weight: 600;
          transition: background 0.2s;
        }

        .btn-primary:hover {
          background: #4338ca;
        }
      `}</style>
    </>
  );
}